/* eslint-disable */
export default function (str) {
  if (!str) return null
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => `-${chr}`)
    .trim()
}
